// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/account/CreateDSAWorkflowTypeSelectionModal.scss
// module id = 1271
// module chunks = 0